// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CreateCertificationShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignCertificationShareActionInput;
}>;


export type CreateCertificationShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { createCertificationShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignCertificationShareActionModel' }
        & Pick<PrivateSchemaTypes.CampaignCertificationShareActionModel, 'id'>
        & { actionCertifications: Array<(
          { __typename?: 'CampaignActionCertificationModel' }
          & Pick<PrivateSchemaTypes.CampaignActionCertificationModel, 'id' | 'certification_id'>
        )> }
      )> }
    )> }
  )> }
);

export type CreatePathwayShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignPathwayShareActionInput;
}>;


export type CreatePathwayShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { createPathwayShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignPathwayShareActionModel' }
        & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModel, 'id'>
        & { actionPathways: Array<(
          { __typename?: 'CampaignActionPathwayModel' }
          & Pick<PrivateSchemaTypes.CampaignActionPathwayModel, 'id' | 'pathway_id'>
        )> }
      )> }
    )> }
  )> }
);

export type CreateSurveyShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignSurveyShareActionInput;
}>;


export type CreateSurveyShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { createSurveyShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignSurveyShareActionModel' }
        & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModel, 'id'>
        & { actionSurveys: Array<(
          { __typename?: 'CampaignActionSurveyModel' }
          & Pick<PrivateSchemaTypes.CampaignActionSurveyModel, 'id' | 'survey_id'>
        )> }
      )> }
    )> }
  )> }
);

export type CreateTopicShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignTopicShareActionInput;
}>;


export type CreateTopicShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { createTopicShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignTopicShareActionModel' }
        & Pick<PrivateSchemaTypes.CampaignTopicShareActionModel, 'id'>
        & { actionTopics: Array<(
          { __typename?: 'CampaignActionTopicModel' }
          & Pick<PrivateSchemaTypes.CampaignActionTopicModel, 'id' | 'topic_id'>
        )> }
      )> }
    )> }
  )> }
);

export type UpdateCertificationShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignCertificationShareActionInput;
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UpdateCertificationShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { certificationShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignCertificationShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignCertificationShareActionModelAsEditor, 'id'>
        & { patch: (
          { __typename?: 'CampaignPathwayShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModel, 'id'>
        ) }
      )> }
    )> }
  )> }
);

export type UpdatePathwayShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignPathwayShareActionInput;
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UpdatePathwayShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { pathwayShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignPathwayShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModelAsEditor, 'id'>
        & { patch: (
          { __typename?: 'CampaignPathwayShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModel, 'id'>
        ) }
      )> }
    )> }
  )> }
);

export type UpdateSurveyShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignSurveyShareActionInput;
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UpdateSurveyShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { surveyShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignSurveyShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModelAsEditor, 'id'>
        & { patch: (
          { __typename?: 'CampaignSurveyShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModel, 'id'>
        ) }
      )> }
    )> }
  )> }
);

export type UpdateTopicShareActionMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignTopicShareActionInput;
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type UpdateTopicShareActionMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { topicShareAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignTopicShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignTopicShareActionModelAsEditor, 'id'>
        & { patch?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignTopicShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignTopicShareActionModel, 'id'>
        )> }
      )> }
    )> }
  )> }
);


export const CreateCertificationShareActionDocument = gql`
    mutation createCertificationShareAction($id: PositiveInt!, $input: CampaignCertificationShareActionInput!) {
  admin {
    campaign(id: $id) {
      id
      createCertificationShareAction(input: $input) {
        id
        actionCertifications {
          id
          certification_id
        }
      }
    }
  }
}
    `;
export type CreateCertificationShareActionMutationFn = Apollo.MutationFunction<CreateCertificationShareActionMutation, CreateCertificationShareActionMutationVariables>;

/**
 * __useCreateCertificationShareActionMutation__
 *
 * To run a mutation, you first call `useCreateCertificationShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificationShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificationShareActionMutation, { data, loading, error }] = useCreateCertificationShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificationShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCertificationShareActionMutation, CreateCertificationShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCertificationShareActionMutation, CreateCertificationShareActionMutationVariables>(CreateCertificationShareActionDocument, options);
      }
export type CreateCertificationShareActionMutationHookResult = ReturnType<typeof useCreateCertificationShareActionMutation>;
export type CreateCertificationShareActionMutationResult = Apollo.MutationResult<CreateCertificationShareActionMutation>;
export type CreateCertificationShareActionMutationOptions = Apollo.BaseMutationOptions<CreateCertificationShareActionMutation, CreateCertificationShareActionMutationVariables>;
export const CreatePathwayShareActionDocument = gql`
    mutation createPathwayShareAction($id: PositiveInt!, $input: CampaignPathwayShareActionInput!) {
  admin {
    campaign(id: $id) {
      id
      createPathwayShareAction(input: $input) {
        id
        actionPathways {
          id
          pathway_id
        }
      }
    }
  }
}
    `;
export type CreatePathwayShareActionMutationFn = Apollo.MutationFunction<CreatePathwayShareActionMutation, CreatePathwayShareActionMutationVariables>;

/**
 * __useCreatePathwayShareActionMutation__
 *
 * To run a mutation, you first call `useCreatePathwayShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathwayShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathwayShareActionMutation, { data, loading, error }] = useCreatePathwayShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePathwayShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePathwayShareActionMutation, CreatePathwayShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePathwayShareActionMutation, CreatePathwayShareActionMutationVariables>(CreatePathwayShareActionDocument, options);
      }
export type CreatePathwayShareActionMutationHookResult = ReturnType<typeof useCreatePathwayShareActionMutation>;
export type CreatePathwayShareActionMutationResult = Apollo.MutationResult<CreatePathwayShareActionMutation>;
export type CreatePathwayShareActionMutationOptions = Apollo.BaseMutationOptions<CreatePathwayShareActionMutation, CreatePathwayShareActionMutationVariables>;
export const CreateSurveyShareActionDocument = gql`
    mutation createSurveyShareAction($id: PositiveInt!, $input: CampaignSurveyShareActionInput!) {
  admin {
    campaign(id: $id) {
      id
      createSurveyShareAction(input: $input) {
        id
        actionSurveys {
          id
          survey_id
        }
      }
    }
  }
}
    `;
export type CreateSurveyShareActionMutationFn = Apollo.MutationFunction<CreateSurveyShareActionMutation, CreateSurveyShareActionMutationVariables>;

/**
 * __useCreateSurveyShareActionMutation__
 *
 * To run a mutation, you first call `useCreateSurveyShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyShareActionMutation, { data, loading, error }] = useCreateSurveyShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSurveyShareActionMutation, CreateSurveyShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSurveyShareActionMutation, CreateSurveyShareActionMutationVariables>(CreateSurveyShareActionDocument, options);
      }
export type CreateSurveyShareActionMutationHookResult = ReturnType<typeof useCreateSurveyShareActionMutation>;
export type CreateSurveyShareActionMutationResult = Apollo.MutationResult<CreateSurveyShareActionMutation>;
export type CreateSurveyShareActionMutationOptions = Apollo.BaseMutationOptions<CreateSurveyShareActionMutation, CreateSurveyShareActionMutationVariables>;
export const CreateTopicShareActionDocument = gql`
    mutation createTopicShareAction($id: PositiveInt!, $input: CampaignTopicShareActionInput!) {
  admin {
    campaign(id: $id) {
      id
      createTopicShareAction(input: $input) {
        id
        actionTopics {
          id
          topic_id
        }
      }
    }
  }
}
    `;
export type CreateTopicShareActionMutationFn = Apollo.MutationFunction<CreateTopicShareActionMutation, CreateTopicShareActionMutationVariables>;

/**
 * __useCreateTopicShareActionMutation__
 *
 * To run a mutation, you first call `useCreateTopicShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicShareActionMutation, { data, loading, error }] = useCreateTopicShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTopicShareActionMutation, CreateTopicShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTopicShareActionMutation, CreateTopicShareActionMutationVariables>(CreateTopicShareActionDocument, options);
      }
export type CreateTopicShareActionMutationHookResult = ReturnType<typeof useCreateTopicShareActionMutation>;
export type CreateTopicShareActionMutationResult = Apollo.MutationResult<CreateTopicShareActionMutation>;
export type CreateTopicShareActionMutationOptions = Apollo.BaseMutationOptions<CreateTopicShareActionMutation, CreateTopicShareActionMutationVariables>;
export const UpdateCertificationShareActionDocument = gql`
    mutation updateCertificationShareAction($id: PositiveInt!, $input: CampaignCertificationShareActionInput!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      certificationShareAction(id: $id) {
        id
        patch(input: $input) {
          id
        }
      }
    }
  }
}
    `;
export type UpdateCertificationShareActionMutationFn = Apollo.MutationFunction<UpdateCertificationShareActionMutation, UpdateCertificationShareActionMutationVariables>;

/**
 * __useUpdateCertificationShareActionMutation__
 *
 * To run a mutation, you first call `useUpdateCertificationShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificationShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificationShareActionMutation, { data, loading, error }] = useUpdateCertificationShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUpdateCertificationShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCertificationShareActionMutation, UpdateCertificationShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCertificationShareActionMutation, UpdateCertificationShareActionMutationVariables>(UpdateCertificationShareActionDocument, options);
      }
export type UpdateCertificationShareActionMutationHookResult = ReturnType<typeof useUpdateCertificationShareActionMutation>;
export type UpdateCertificationShareActionMutationResult = Apollo.MutationResult<UpdateCertificationShareActionMutation>;
export type UpdateCertificationShareActionMutationOptions = Apollo.BaseMutationOptions<UpdateCertificationShareActionMutation, UpdateCertificationShareActionMutationVariables>;
export const UpdatePathwayShareActionDocument = gql`
    mutation updatePathwayShareAction($id: PositiveInt!, $input: CampaignPathwayShareActionInput!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      pathwayShareAction(id: $id) {
        id
        patch(input: $input) {
          id
        }
      }
    }
  }
}
    `;
export type UpdatePathwayShareActionMutationFn = Apollo.MutationFunction<UpdatePathwayShareActionMutation, UpdatePathwayShareActionMutationVariables>;

/**
 * __useUpdatePathwayShareActionMutation__
 *
 * To run a mutation, you first call `useUpdatePathwayShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathwayShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathwayShareActionMutation, { data, loading, error }] = useUpdatePathwayShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUpdatePathwayShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePathwayShareActionMutation, UpdatePathwayShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePathwayShareActionMutation, UpdatePathwayShareActionMutationVariables>(UpdatePathwayShareActionDocument, options);
      }
export type UpdatePathwayShareActionMutationHookResult = ReturnType<typeof useUpdatePathwayShareActionMutation>;
export type UpdatePathwayShareActionMutationResult = Apollo.MutationResult<UpdatePathwayShareActionMutation>;
export type UpdatePathwayShareActionMutationOptions = Apollo.BaseMutationOptions<UpdatePathwayShareActionMutation, UpdatePathwayShareActionMutationVariables>;
export const UpdateSurveyShareActionDocument = gql`
    mutation updateSurveyShareAction($id: PositiveInt!, $input: CampaignSurveyShareActionInput!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      surveyShareAction(id: $id) {
        id
        patch(input: $input) {
          id
        }
      }
    }
  }
}
    `;
export type UpdateSurveyShareActionMutationFn = Apollo.MutationFunction<UpdateSurveyShareActionMutation, UpdateSurveyShareActionMutationVariables>;

/**
 * __useUpdateSurveyShareActionMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyShareActionMutation, { data, loading, error }] = useUpdateSurveyShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUpdateSurveyShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSurveyShareActionMutation, UpdateSurveyShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSurveyShareActionMutation, UpdateSurveyShareActionMutationVariables>(UpdateSurveyShareActionDocument, options);
      }
export type UpdateSurveyShareActionMutationHookResult = ReturnType<typeof useUpdateSurveyShareActionMutation>;
export type UpdateSurveyShareActionMutationResult = Apollo.MutationResult<UpdateSurveyShareActionMutation>;
export type UpdateSurveyShareActionMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyShareActionMutation, UpdateSurveyShareActionMutationVariables>;
export const UpdateTopicShareActionDocument = gql`
    mutation updateTopicShareAction($id: PositiveInt!, $input: CampaignTopicShareActionInput!, $campaignId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      topicShareAction(id: $id) {
        id
        patch(input: $input) {
          id
        }
      }
    }
  }
}
    `;
export type UpdateTopicShareActionMutationFn = Apollo.MutationFunction<UpdateTopicShareActionMutation, UpdateTopicShareActionMutationVariables>;

/**
 * __useUpdateTopicShareActionMutation__
 *
 * To run a mutation, you first call `useUpdateTopicShareActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicShareActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicShareActionMutation, { data, loading, error }] = useUpdateTopicShareActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUpdateTopicShareActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTopicShareActionMutation, UpdateTopicShareActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTopicShareActionMutation, UpdateTopicShareActionMutationVariables>(UpdateTopicShareActionDocument, options);
      }
export type UpdateTopicShareActionMutationHookResult = ReturnType<typeof useUpdateTopicShareActionMutation>;
export type UpdateTopicShareActionMutationResult = Apollo.MutationResult<UpdateTopicShareActionMutation>;
export type UpdateTopicShareActionMutationOptions = Apollo.BaseMutationOptions<UpdateTopicShareActionMutation, UpdateTopicShareActionMutationVariables>;